import { ListingCondition, PurchaseRequest } from 'types';

type SplitPurchaseRequests = {
  [ListingCondition.Unworn]: PurchaseRequest[];
  [ListingCondition.Preowned]: PurchaseRequest[];
};

export const getSplitPurchaseRequests = (purchaseRequests: PurchaseRequest[]) =>
  purchaseRequests
    .sort((a, b) => b.requestedPriceCents - a.requestedPriceCents)
    .reduce<SplitPurchaseRequests>(
      (acc, val) => {
        if (val?.unwornRestriction === 'REQUIRE') {
          acc[ListingCondition.Unworn].push(val);
        } else {
          acc[ListingCondition.Preowned].push(val);
        }

        return acc;
      },
      {
        [ListingCondition.Unworn]: [],
        [ListingCondition.Preowned]: []
      }
    );
